import { axiosWrapper } from '../../lib/axios-wrapper/axios-wrapper';
import { globalLogger } from './global-logger';

function bytesToBase64(bytes) {
    const binString = Array.from(bytes, (x) => String.fromCodePoint(x)).join('');
    return btoa(binString);
}

async function encodeImageToBase64(imageUrl) {
    try {
        const response = await axiosWrapper.get(imageUrl, {}, { responseType: 'blob' });
        const blob = await response.data;
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result.split(',')[1]);
            };
            reader.onerror = () => {
                reject(new Error('Error reading image'));
            };
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        globalLogger.log('base64 - encodeImageToBase64 - error encoding image to base64', error);
        return null;
    }
}

function decodeBase64ToImageUrl(base64String, mimeType) {
    return `data:${mimeType || 'image/jpeg'};base64,${base64String}`;
}

export { bytesToBase64, encodeImageToBase64, decodeBase64ToImageUrl };
